import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import ProgressBar from "./components/ProgressBar";
import Container from "./components/Container";
import Background from "./components/Background";
import SectionOne from "./components/SectionOne";
import SectionTwo from "./components/SectionTwo";
import SectionThree from "./components/SectionThree";
import SectionFour from "./components/SectionFour";
import SectionFive from "./components/SectionFive";
import SectionSix from "./components/SectionSix";
import SectionSeven from "./components/SectionSeven";
import SectionEight from "./components/SectionEight";
import ScrollTop from "./components/ScrollTop";

export default function App() {
  const [progress, setProgress] = useState(0);

  const handleScroll = () => {
    const mynavbar = document.getElementById("myNav");
    const scrolltop = document.getElementById("scrollTop");
    if (window.scrollY > 40) {
      mynavbar.classList.add("shadow-lg");
      mynavbar.classList.remove("pt-5");
      scrolltop.classList.add("bottom-3");
      scrolltop.classList.remove("-bottom-10");
    } else {
      mynavbar.classList.remove("shadow-lg");
      mynavbar.classList.add("pt-5");
      scrolltop.classList.add("-bottom-10");
      scrolltop.classList.remove("bottom-3");
    }

    var h = document.documentElement,
      b = document.body,
      st = "scrollTop",
      sh = "scrollHeight";

    var percent =
      ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;

    setProgress(percent);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });

  return (
    <div className="font-roboto overflow-x-hidden">
      <ProgressBar width={progress} />
      <Navbar />

      <Background variant="bgsec1" position="bottom">
        <Container className="pt-24 md:min-h-screen">
          <SectionOne />
        </Container>
      </Background>

      <div className="bg-yellow-creatifa">
        <Background variant="bgsec2" position="top">
          <Container className="md:pt-36 pt-10 md:min-h-screen">
            <SectionTwo />
          </Container>
        </Background>
      </div>

      <div className="bg-yellow-creatifa">
        <Background variant="bgsec3" position="bottom">
          <Container className="md:pb-52 md:pt-24 pb-10 pt-10 md:min-h-screen">
            <SectionThree />
          </Container>
        </Background>
      </div>

      <div className="bg-red-creatifa">
        <Background variant="bgsec4" position="top">
          <Container className="md:py-36 py-10 md:min-h-screen">
            <SectionFour />
          </Container>
        </Background>
      </div>

      <div className="bg-red-creatifa">
        <Background variant="bgsec5" position="bottom">
          <Container className="md:pb-40 py-10 md:min-h-screen">
            <SectionFive />
          </Container>
        </Background>
      </div>

      <div className="bg-white">
        <Background variant="bgsec6" position="top">
          <Container className="md:py-36 py-10 md:min-h-screen">
            <SectionSix />
          </Container>
        </Background>
      </div>

      <div className="bg-white">
        <Background variant="bgsec7" position="bottom">
          <Container className="md:py-36 py-10 md:min-h-screen">
            <SectionSeven />
          </Container>
        </Background>
      </div>

      <div className="bg-yellow-creatifa">
        <Background variant="bgsec8" position="top">
          <Container className="md:py-36 py-10 md:min-h-screen">
            <SectionEight />
          </Container>
        </Background>
      </div>

      <ScrollTop />
    </div>
  );
}
